import { ItemIconSettings } from '../../../types/Admin/ItemIconTypes';
import { defaultItemIconSettings } from '../../mediaBackground';

export const parseItemIconSettings = (
  source?: Partial<ItemIconSettings> | null
): ItemIconSettings => ({
  iconUrl: source?.iconUrl && source.iconUrl !== '' ? source.iconUrl : null,
  iconFitMode: source?.iconFitMode ?? defaultItemIconSettings.iconFitMode,
  iconScale: source?.iconScale ?? defaultItemIconSettings.iconScale,
  iconPositionX: source?.iconPositionX ?? defaultItemIconSettings.iconPositionX,
  iconPositionY: source?.iconPositionY ?? defaultItemIconSettings.iconPositionY
});
